import { ChangeDetectionStrategy, Component, Input, Self, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { DynamicFormComponent } from 'core/dynamic-form';
import { Subject, combineLatest, map, takeUntil } from 'rxjs';
import { ActorAuthService } from './actor-auth.service';

@Component({
  selector: 'ss-actor-auth',
  templateUrl: './actor-auth.component.html',
  styleUrls: ['./actor-auth.component.scss'],
  providers: [
    ActorAuthService
  ],
  host: {
    class: 'flex-column'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ActorAuthComponent {

  private readonly _destroy = new Subject<void>()

  @ViewChild('checkbox')
  private _checkbox: MatCheckbox

  @ViewChild('form')
  private _form: DynamicFormComponent

  readonly actorAuthDefSubject = this._actorAuthService.actorAuthDefSubject;
  @Input() get actorAuthDef() {
    return this.actorAuthDefSubject.value
  }
  set actorAuthDef(value) {
    this.actorAuthDefSubject.next(value)
  }

  readonly checkedSubject = this._actorAuthService.checkedSubject;
  get checked() {
    return this.checkedSubject.value;
  }

  readonly showFormObs = combineLatest([
    this.actorAuthDefSubject,
    this.checkedSubject
  ])
    .pipe(
      map(([{ controls }, checked]) => Boolean(controls && checked))
    )


  get isValid() {
    return this._actorAuthService.isValid;
  }

  readonly formSubject = this._actorAuthService.formSubject;
  constructor(
    @Self() private readonly _actorAuthService: ActorAuthService
  ) {

  }

  ngAfterViewInit() {

    this._checkbox.change
      .pipe(
        takeUntil(this._destroy)
      )
      .subscribe(({ checked }) => {
        this.checkedSubject.next(checked)
      })

    this.formSubject.next(this._form)
  }

  submit() {

    const formData = this._form?.mainFormGroup?.value

    return {
      name: this.actorAuthDef.type,
      formData,
    }
  }

  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
